import {
  fetchBscFinancialGoals,
  fetchBscCustomerValueGoals,
  fetchBscStrategicGoalGoals,
  fetchBscStrategicIssueGoals,
  fetchBscHumanCapitalGoalGoals,
  fetchBscHumanCapitalIssueGoals,
  fetchBscInfoCapitalGoalAppGoals,
  fetchBscInfoCapitalGoalDataGoals,
  fetchBscInfoCapitalGoalItGoals,
  fetchBscInfoCapitalIssueAppGoals,
  fetchBscInfoCapitalIssueDataGoals,
  fetchBscInfoCapitalIssueItGoals,
  fetchBscOrgCapitalGoalGoals,
  fetchBscOrgCapitalIssueGoals,
  fetchFinancialGoals,
  fetchCustomerValues,
  fetchStrategicGoals,
  fetchStrategicIssues,
  fetchHumanCapitalGoals,
  fetchHumanCapitalIssues,
  fetchInfoCapitalGoalsApp,
  fetchInfoCapitalGoalsData,
  fetchInfoCapitalGoalsIt,
  fetchInfoCapitalIssuesApp,
  fetchInfoCapitalIssuesData,
  fetchInfoCapitalIssuesIt,
  fetchOrgCapitalGoals,
  fetchOrgCapitalIssues,
} from "../../../api/companyApi";

const combineFetch =
  (fetchGoalsFn, fetchIssuesFn) =>
  async (domainId) => {
    const [goals, issues] = await Promise.all([
      fetchGoalsFn(domainId).catch(() => []),
      fetchIssuesFn(domainId).catch(() => []),
    ]);
    return [
      ...(Array.isArray(goals) ? goals : []),
      ...(Array.isArray(issues) ? issues : []),
    ];
  };

/**
 * BSC カテゴリごとの設定
 * fetchGoals(businessUnitId)        → GET でゴール一覧を取得
 * fetchSuccessFactors(domainId)     → 目標新規作成時にSuccessFactorドロップダウンを取得
 * titleKey                          → 一覧ページのタイトル i18n キー
 */
export const BSC_CATEGORY_CONFIG = {
  "financial-goals": {
    fetchGoals: fetchBscFinancialGoals,
    fetchSuccessFactors: fetchFinancialGoals,
    titleKey: "bsc.financialGoals.title",
  },
  "customer-values": {
    fetchGoals: fetchBscCustomerValueGoals,
    fetchSuccessFactors: fetchCustomerValues,
    titleKey: "bsc.customerValues.title",
  },
  "strategic-goals": {
    fetchGoals: fetchBscStrategicGoalGoals,
    fetchSuccessFactors: fetchStrategicGoals,
    titleKey: "bsc.strategicGoals.title",
  },
  "strategic-issues": {
    fetchGoals: fetchBscStrategicIssueGoals,
    fetchSuccessFactors: fetchStrategicIssues,
    titleKey: "bsc.strategicIssues.title",
  },
  "human-capital-goals": {
    fetchGoals: combineFetch(fetchBscHumanCapitalGoalGoals, fetchBscHumanCapitalIssueGoals),
    fetchSuccessFactors: combineFetch(fetchHumanCapitalGoals, fetchHumanCapitalIssues),
    titleKey: "bsc.humanCapitalGoals.title",
  },
  "info-capital-goals-app": {
    fetchGoals: combineFetch(fetchBscInfoCapitalGoalAppGoals, fetchBscInfoCapitalIssueAppGoals),
    fetchSuccessFactors: combineFetch(fetchInfoCapitalGoalsApp, fetchInfoCapitalIssuesApp),
    titleKey: "bsc.infoCapitalGoalsApp.title",
  },
  "info-capital-goals-data": {
    fetchGoals: combineFetch(fetchBscInfoCapitalGoalDataGoals, fetchBscInfoCapitalIssueDataGoals),
    fetchSuccessFactors: combineFetch(fetchInfoCapitalGoalsData, fetchInfoCapitalIssuesData),
    titleKey: "bsc.infoCapitalGoalsData.title",
  },
  "info-capital-goals-it": {
    fetchGoals: combineFetch(fetchBscInfoCapitalGoalItGoals, fetchBscInfoCapitalIssueItGoals),
    fetchSuccessFactors: combineFetch(fetchInfoCapitalGoalsIt, fetchInfoCapitalIssuesIt),
    titleKey: "bsc.infoCapitalGoalsIt.title",
  },
  "org-capital-goals": {
    fetchGoals: combineFetch(fetchBscOrgCapitalGoalGoals, fetchBscOrgCapitalIssueGoals),
    fetchSuccessFactors: combineFetch(fetchOrgCapitalGoals, fetchOrgCapitalIssues),
    titleKey: "bsc.orgCapitalGoals.title",
  },
};
